import React, { useState } from 'react';
import { useLanguage } from '../providers/preferenceProvider';
import logo from '../media/logo.svg';
import '../css/login.css';
import { useSearchParams } from 'react-router-dom';
import { createPasswordReset } from '../api/password-api';

const PasswordReset = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get('email'));
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (!email || loading) return;

    setLoading(true);

    try {
      await createPasswordReset(email, false);
    } catch (error) {
      // Still show success message even if backend is vague on user existence
    } finally {
      setMessageSent(true);
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <main className="main-container">
          <div className="login-box">
            <div className="main-header">{t.forgot_password}</div>
            <div className="form-container">
              <div className="login-content">
                {!messageSent ? (
                  <form className="login-form" onSubmit={handleReset}>
                    <input
                      type="email"
                      placeholder={t.email + "..."}
                      value={email}
                      onChange={handleEmailChange}
                      required
                    />
                    <button type="submit" disabled={loading}>
                      {t.reset_password}
                    </button>
                  </form>
                ) : (
                  <p className="form-message">
                    {t.toast.reset_email_sent_message} 
                  </p>
                )}
              </div>
              <div className="login-logo">
                <img src={logo} alt="42Workspace" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PasswordReset;
